import { useMemo, type ReactNode } from 'react'

import { env } from '@/lib/env.ts'

import { TenantContext } from './TenantContext.ts'
import { resolveTenant } from './tenant.ts'

interface TenantProviderProps {
  readonly children: ReactNode
}

/**
 * Resolves the active tenant from the current URL once per mount.
 *
 * Stage 6 replaces this with a resolver that also fetches the tenant record and
 * handles unknown slugs; the consumer API (`useTenant`) stays the same.
 */
export function TenantProvider({ children }: TenantProviderProps) {
  const value = useMemo(
    () => resolveTenant(new URL(window.location.href), env.VITE_DEFAULT_TENANT_SLUG),
    [],
  )

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
}
